import { APRECOMM_GRAPH_URL } from '../../constants/commonConstants';
import {
	APRECOM_SITE_LIST_DETAILS,
	APRECOM_SITE_LIST_ERROR,
	APRECOM_SITE_LIST_LOADING,
} from '../../constants/graphConstants/connectedClientsGraphConstants';
import { logout } from '../userActions.js';
import { decryptData } from '../../utils/crypto';
import aprecomAxios  from '../../utils/aprecomApiInterceptor.js';

export const siteListQuery = () => async (dispatch, getState) => {
	try {
		const APPRECOM_CUST_ID = Number(decryptData(localStorage.getItem('aprecom_custId')));
		const APPRECOM_CUSTID = APPRECOM_CUST_ID
			? parseInt(APPRECOM_CUST_ID, 10)
			: null;
		const body = {
			operationName: 'siteListQuery',
			variables: {
				custId: APPRECOM_CUSTID,
			},
			query: 'query siteListQuery($custId: Int) {\n  sites {\n    siteList(custId: $custId) {\n      siteId\n      siteName\n      lat\n      long\n      __typename\n    }\n    __typename\n  }\n}\n',
		};

		const APPRECOM_BASE_URL = decryptData(localStorage.getItem('aprecom_url'));

		if (APPRECOM_BASE_URL) {
			const url = APPRECOM_BASE_URL + APRECOMM_GRAPH_URL;
			const { data } = await aprecomAxios.post(url, JSON.stringify(body));

			dispatch({
				type: APRECOM_SITE_LIST_LOADING,
				payload: false,
			});

			if (data) {
				dispatch({
					type: APRECOM_SITE_LIST_DETAILS,
					payload: data?.data?.sites?.siteList || [],
				});
			} else {
				dispatch({
					type: APRECOM_SITE_LIST_DETAILS,
					payload: [],
				});
			}
		}else {
			dispatch({
				type: APRECOM_SITE_LIST_ERROR,
				payload: {
					siteError: 'Token Expired. Please re-login',
					siteList: []
				},
			});
		}
	} catch (error) {
		if(error?.response && error?.response?.data 
			&& (
				error?.response?.data?.errors[0]?.message === 'user not authorized due to [TokenExpiredError: jwt expired]'
				|| error?.response?.data?.errors[0]?.message === "user not authorized due to [JsonWebTokenError: jwt malformed]"
				|| error?.response?.data?.errors[0]?.message === "user not authorized due to [JsonWebTokenError: invalid signature]"
			)
		){
			dispatch(logout());
		}
		dispatch({
			type: APRECOM_SITE_LIST_ERROR,
			payload: {
				siteError: 'Token Expired. Please re-login',
				siteList: []
			},
		});
	}
};
